import moment from 'moment';

// Helper function to check if the version supports RTF Metrics
export const isVersionSupported = (esVersion) => {
  if (esVersion === "N/A") return true;
  
  // If it's an ES version, not supported
  if (esVersion.startsWith('ES_')) {
    return false;
  }
  
  // If it's an OS version, check the version number
  if (esVersion.startsWith('OS_')) {
    try {
      const versionString = esVersion.substring(3); // Remove "OS_"
      const versionParts = versionString.split('.');
      
      const majorVersion = parseInt(versionParts[0], 10);
      const minorVersion = parseFloat(versionParts.slice(1).join('.'));
      
      // Check if parsing was successful
      if (isNaN(majorVersion) || isNaN(minorVersion)) {
        // If we can't parse the version, return true
        return true;
      }
      
      // For OS, need version 2.15 or higher
      return (majorVersion > 2) || (majorVersion === 2 && minorVersion >= 15);
    } catch (e) {
      // If we can't parse the version, return true
      return true;
    }
  }
};

// Helper function to check if the selected date is within 1 month from now
export const isWithinOneMonth = (date) => {
  const oneMonthAgo = moment().subtract(1, 'month');
  return moment(date).isAfter(oneMonthAgo);
};

// Function to validate if the date range is acceptable i.e. is date rage within past 1 month duration from present.
export const isDateRangeValid = (dateRange) => {
  if (dateRange.type === 'absolute') {
    const startIsValid = isWithinOneMonth(dateRange.startDate);
    return startIsValid;
  } else if (dateRange.type === 'relative') {
    // For relative ranges, check if the calculated start time is within limit
    const startMoment = moment().subtract(dateRange.amount, dateRange.unit);
    const oneMonthAgo = moment().subtract(1, 'month');
    return startMoment.isAfter(oneMonthAgo);
  }
  return true;
};

// Function to render RTF Metrics description
export const renderRTFMetricsDescription = () => {
  return (
    <div>
      <p>
        Request Tracing Framework (RTF) Metrics provide detailed information about various aspects of the OpenSearch domain which can
        be used to identify root causing issues, and visualising domain health.
      </p>
      <br />
      <p>
        In RTF we are emitting metrics which are of Node and Shard level Cardinality. These metrics are emmitted from each instance of the domain at a regular 
        interval of 1 minute, hence the values of metrics are aggregated over 1 minute duration.
      </p>
      <br />
    </div>
  );
};